// extracted by mini-css-extract-plugin
module.exports = {"avatarGroupWithModalDisabled":"DonateToGroupMemberAvtatars_avatarGroupWithModalDisabled__2hRO_"};